module.exports = __webpack_public_path__ + "static/media/daisy-logo.f2c994db.png";